var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-tag",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"game-icon"},[_c('game-icon',{attrs:{"name":_vm.game.code}})],1),(_vm.displayName)?_c('div',{staticClass:"game-name"},[_vm._v(" "+_vm._s(_vm.gameName)+" "),_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }